import { HttpClient, HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { PageService } from 'src/app/core/services/page.service';
interface AuditLogItem {
  timestamp: Date;
  module: string;
  activity: string;
  user: string;
  email: string;
  description: string;
}

@Component({
    selector: 'app-audittrails',
    templateUrl: './audittrails.component.html',
    styleUrls: ['./audittrails.component.css'],
    standalone: false
})
export class AudittrailsComponent {
  protected Math = Math;
  sortBy: string = 'name';

  // Main data
  auditLogs: AuditLogItem[] = [];
  filteredData: AuditLogItem[] = [];

  // Filters
  modules: string[] = ['Connections', 'Documents', 'Health', 'Notifications'];
  activities: string[] = ['Shared Document', 'File Upload', 'User Login', 'User Registration'];
  selectedModule: string = '';
  selectedActivity: string = '';
  searchQuery: string = '';
  advancedSearch: boolean = false;

  // Loading states
  isLoading: boolean = false;
  errorMessage: string = '';

  // Sorting
  sortField: string = 'timestamp';
  sortDirection: 'asc' | 'desc' = 'desc';

  sortOptions = [
    { label: 'Sort by Name', icon: 'sort_by_alpha', action: () => this.onSort('name') },
    { label: 'Sort by Date', icon: 'date_range', action: () => this.onSort('date') },
  ];

  // Pagination
  // pageSize: number = 5;
  // currentPage: number = 1;
  // startIndex: number = 0;
  // //endIndex: number = 5;
  // endIndex = this.pageSize;
  // totalPages = 1;


  pagedData: AuditLogItem[] = [];
  // initialize defaults
  pageSize: number = 5;
  currentPage: number = 1;
  startIndex: number = 0;
  endIndex: number = 0;
  totalPages: number = 1;

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private pageService: PageService,
    private authService: AuthService,
  ) { }

  ngOnInit() {
    this.pageService.setCurrentPage('Audit Trails');
    this.fetchAuditLogs();
  }

  fetchAuditLogs() {
    this.isLoading = true;
    this.errorMessage = '';

    let params = new HttpParams();

    if (this.selectedModule) {
      params = params.set('module', this.selectedModule);
    }

    if (this.selectedActivity) {
      params = params.set('activity', this.selectedActivity);
    }

    this.authService.get_audit_trails().subscribe({
      next: (response: any) => {
        if (response && response.data.events && response.data.events.length > 0) {
          this.auditLogs = response.data.events.map((item: any) => ({
            timestamp: new Date(item.timestamp),
            module: item.department_name || 'Connections',
            activity: item.activity || 'Shared Document',
            user: item.user_name || 'John Smith',
            email: item.user_email || 'smith23456@gmail.com',
            description: item.message || 'Shared folder updated.'
          }));
          //console.log('auditLogs',this.auditLogs)

          // Sort by timestamp in descending order initially
          this.sortData('timestamp');
          this.applyFilters();
        } else {
          this.errorMessage = 'No data available';
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.errorMessage = 'Failed to load audit logs. Please try again.';
        this.isLoading = false;
        console.error('Error fetching audit logs:', error);
      }
    });
  }

  // get_audit_trails(params: HttpParams) {
  //   // Replace the URL below with your actual API endpoint
  //   const url = '/api/audit-trails';
  //   return this.http.get<any>(url, { params });
  // }

  onFilterChange() {
    this.currentPage = 1;
    this.fetchAuditLogs();
  }

  toggleAdvancedSearch() {
    // Implement advanced search logic here
    console.log('Advanced search:', this.advancedSearch);
  }

  applyFilter(event?: Event) {
    if (event) {
      this.searchQuery = (event.target as HTMLInputElement).value.trim().toLowerCase();
    }
    this.applyFilters();
  }


  onSort(criteria: string): void {
    this.sortBy = criteria;
    this.fetchAuditLogs();
  }

  applyFilters() {
    this.filteredData = [...this.auditLogs];

    if (this.searchQuery) {
      this.filteredData = this.filteredData.filter(item =>
        item.module.toLowerCase().includes(this.searchQuery) ||
        item.activity.toLowerCase().includes(this.searchQuery) ||
        item.user.toLowerCase().includes(this.searchQuery) ||
        item.email.toLowerCase().includes(this.searchQuery) ||
        item.description.toLowerCase().includes(this.searchQuery) ||
        new Date(item.timestamp).toLocaleString().toLowerCase().includes(this.searchQuery)
      );
    }

    this.currentPage = 1; // always reset to first page after filtering
    this.calculatePagination();
    //this.updatePagination();
  }

  private calculatePagination() {
    // ensure pageSize is a number
    this.pageSize = Number(this.pageSize) || 5;

    const total = this.filteredData?.length || 0;
    this.totalPages = Math.max(1, Math.ceil(total / this.pageSize));

    // clamp currentPage
    if (this.currentPage < 1) this.currentPage = 1;
    if (this.currentPage > this.totalPages) this.currentPage = this.totalPages;

    this.startIndex = (this.currentPage - 1) * this.pageSize;
    this.endIndex = Math.min(this.startIndex + this.pageSize, total); // IMPORTANT clamp

    // create the sliced array once and bind to template
    if (total > 0) {
      this.pagedData = this.filteredData.slice(this.startIndex, this.endIndex);
    } else {
      this.pagedData = [];
      this.startIndex = 0;
      this.endIndex = 0;
    }
  }

  /** when user changes rows-per-page */
  onPageSizeChange(event?: Event) {
    if (event) {
      const v = (event.target as HTMLSelectElement).value;
      this.pageSize = Number(v) || this.pageSize;
    }
    this.currentPage = 1;
    this.calculatePagination();
  }

  /** next/prev */
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.calculatePagination();
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.calculatePagination();
    }
  }

  updatePagination() {
    // Always clamp currentPage to the max number of pages
    const maxPage = Math.ceil(this.filteredData.length / this.pageSize);
    if (this.currentPage > maxPage) {
      this.currentPage = 1; // reset if out of range
    }

    this.startIndex = (this.currentPage - 1) * this.pageSize;
    this.endIndex = this.startIndex + this.pageSize;
  }
  
  sortData(field: string) {
    if (this.sortField === field) {
      // Toggle direction if clicking the same field
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'desc'; // Default to descending for new sort field
    }

    this.filteredData.sort((a: any, b: any) => {
      const valueA = a[field];
      const valueB = b[field];

      // Date comparison
      if (field === 'timestamp') {
        return this.sortDirection === 'asc'
          ? new Date(valueA).getTime() - new Date(valueB).getTime()
          : new Date(valueB).getTime() - new Date(valueA).getTime();
      }

      // String comparison
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        const comparison = valueA.localeCompare(valueB);
        return this.sortDirection === 'asc' ? comparison : -comparison;
      }

      // Default comparison
      return this.sortDirection === 'asc'
        ? (valueA > valueB ? 1 : -1)
        : (valueA < valueB ? 1 : -1);
    });

    // this.updatePagination();
    this.calculatePagination(); // after sorting we still need to recalc indices:
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) {
      return 'bi-arrow-down-up';
    }
    return this.sortDirection === 'asc' ? 'bi-sort-up' : 'bi-sort-down';
  }

  // updatePagination() {
  //   this.startIndex = (this.currentPage - 1) * this.pageSize;
  //   this.endIndex = this.startIndex + this.pageSize;
  // }

  // onPageSizeChange() {
  //   this.currentPage = 1; // reset to first page
  //   this.updatePagination();
  // }

  // prevPage() {
  //   if (this.currentPage > 1) {
  //     this.currentPage--;
  //     this.updatePagination();
  //   }
  // }

  // nextPage() {
  //   if (this.currentPage * this.pageSize < this.filteredData.length) {
  //     this.currentPage++;
  //     this.updatePagination();
  //   }
  // }

  getUserInitials(name: string): string {
    if (!name) return '';

    const parts = name.split(' ');
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
    return;
  }
}
